var $export = require('./$.export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./$.string-repeat')
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.string.repeat.js
// module id = 246
// module chunks = 0